export function getUGCPreviewEntries(recipe = {}) {
  const components = recipe.components || {};

  return Object.keys(components).reduce((entries, componentName) => {
    const component = components[componentName];
    const imageUrl = component &&
      component.ugc &&
      component.ugc.ugc_swatch &&
      component.ugc.ugc_swatch.image_url;

    if (imageUrl) entries.push({ componentName, imageUrl });
    return entries;
  }, []);
}
